import Vue from 'vue';
import { mutationTypes, errorTypes } from '@/types';

// create style node for styleTemplate for the content this href attribute will be set later
const $css = document.createElement('style');

export default async function setStyleUrl({ state, commit }, { styleTemplateURL, styleTemplateHashes = [] }) {
	if (styleTemplateURL === state.styleTemplateURL) return;
	commit(mutationTypes.setStyleUrl, { styleTemplateURL });
	commit(mutationTypes.setStyleLoaded, { status: false });
	let result;
	try {
		result = await Vue.http.get(styleTemplateURL, { credentials: false });
	} catch (error) {
		new Error(errorTypes.failedLoadingStyles);
		// dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.failedLoadingStyles) });
		return;
	}
	// Since the `url()` values use relative paths (if not `url('data:..')` is used)
	// we need to make them absolute relative the the location of the loaded style sheet.
	const urlParts = styleTemplateURL.split('/');
	urlParts.pop();
	// Replace all files linked in the styletemplate with cache breaking URLs
	$css.innerHTML = styleTemplateHashes.reduce(
		(acc, [name, hash]) => acc.replace(name, `${name}?v=${hash}`),
		result.body.replace(/url\(([^'"])/g, `url(${urlParts.join('/')}/$1`)
	);
	if (!$css.parentNode) document.head.appendChild($css);

	// Check the version of the CSS stylsheet and compare
	// the major version with the on of this webclient.
	// If they missmatch the API could be different. If this
	// is the case show a warning.
	commit(mutationTypes.setStyleLoaded, { status: true });
}
